// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oc-1";
export var stateContainer = "_oc-0";